import { QueryClientProvider, queryClient } from '@frontend/api';
import { theme, createStandaloneToast } from '@frontend/components';

import NotificationToast from './components/subcomponents/NotificationToast';
import { NOTIFICATION_TYPES } from './data/constants';

const notificationFlash = ({
  groupId,
  notification,
  thumbnailBlob,
  userGroupMembers,
}) => {
  const { toast } = createStandaloneToast({ theme });
  const duration = 10000;

  switch (notification.type) {
    case NOTIFICATION_TYPES.CHANNEL_EVENT:
    case NOTIFICATION_TYPES.CHANNEL_MENTION:
    case NOTIFICATION_TYPES.CHANNEL_REPLY:
    case NOTIFICATION_TYPES.CHAT_REPLY:
    case NOTIFICATION_TYPES.PARTBOT_REPLY:
    case NOTIFICATION_TYPES.SHARE_REINITIALIZATION_REQUEST:
    case NOTIFICATION_TYPES.TASKS:
    case NOTIFICATION_TYPES.THREAD_MENTION: {
      toast({
        position: 'top-end',
        render: ({ onClose }) => (
          <QueryClientProvider client={queryClient}>
            <NotificationToast
              notification={notification}
              groupId={groupId}
              isThumbnail={true}
              thumbnailBlob={thumbnailBlob}
              onClose={onClose}
              userGroupMembers={userGroupMembers}
            />
          </QueryClientProvider>
        ),
        duration,
        isClosable: true,
      });
      break;
    }

    case NOTIFICATION_TYPES.ASSIGNED_TO_ACTION:
    case NOTIFICATION_TYPES.DIGIQUOTE_VIEW:
    case NOTIFICATION_TYPES.ESTIMATOR_ASSIGNMENT:
    case NOTIFICATION_TYPES.INTEGRATION_ACTION_FAILURE:
    case NOTIFICATION_TYPES.MANUAL_INPUT_COMPLETED:
    case NOTIFICATION_TYPES.NEW_QUOTE_FROM_EMAIL:
    case NOTIFICATION_TYPES.NEW_RFQ:
    case NOTIFICATION_TYPES.NEW_SUBQUOTE: {
      toast({
        position: 'top-end',
        render: ({ onClose }) => (
          <QueryClientProvider client={queryClient}>
            <NotificationToast
              notification={notification}
              groupId={groupId}
              isThumbnail={false}
              onClose={onClose}
              userGroupMembers={userGroupMembers}
            />
          </QueryClientProvider>
        ),
        duration,
        isClosable: true,
      });
      break;
    }
    default:
      console.error('Received notification of unknown type', notification);
      break;
  }
};

export default notificationFlash;
